import { render } from "./ConfirmPhone.vue?vue&type=template&id=987d45e6&scoped=true&ts=true"
import script from "./ConfirmPhone.vue?vue&type=script&lang=ts"
export * from "./ConfirmPhone.vue?vue&type=script&lang=ts"

import "./ConfirmPhone.vue?vue&type=style&index=0&id=987d45e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-987d45e6"]])

export default __exports__